module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/electricity-1.webp";